import { useParams } from "react-router-dom";
import { useGetLienFileByIdQuery } from "services/lien-api";

export const useLienFileData = () => {
  const { lienFileId } = useParams<{ lienFileId?: string }>();

  const {
    data: lienFileData,
    isLoading,
    error,
    refetch,
  } = useGetLienFileByIdQuery(
    { fileId: lienFileId || "" },
    { skip: !lienFileId },
  );

  return {
    lienFileData,
    workspaceUrl: lienFileData?.service?.workspace_url,
    isLoading,
    error,
    refetch,
  };
};
